import { Pagination } from '~/app/shared/table3tools/types';

export default function parsePagination(pagination?: Pagination): string {
    if (!pagination) {
        return `returnAll=true`;
    }

    return `pageSize=${pagination.pageSize}&skipPages=${pagination.pageIndex}`;
}
